import React from 'react';

const MissionAIForGoodOverview = () => {
    return (
        <div className="document">
            <h1>Mission Statement to Students</h1>
            <p><strong>Dear Future Digital Detectives, 🔍🔎</strong></p>
            <p>Welcome to HackTonIA HackTivity, where you'll transform from technology consumers into creative
                problem-solvers and digital creators! 🚀 Our mission is to equip you with the skills to direct AI tools
                rather than be directed by them. (Because let's face it, if robots are going to take over the world, you
                might as well be the one telling them what to do! 😉)</p>

            <p>Through our detective-based learning approach, you'll investigate how digital technologies work, uncover
                the patterns and structures behind websites and applications, and learn to communicate effectively with
                artificial intelligence. Think of it as CSI: Cyber Edition, but with less crime and more creating!
                🕵️‍♂️💡</p>

            <p>At HackTonIA, we believe that understanding how technology works gives you the power to create with it.
                You don't need to become a traditional coder—instead, you'll become something more valuable: a
                technology director who can harness AI tools to bring your ideas to life. It's like having a digital
                genie without the three-wish limit! 🧞‍♂️✨</p>

            <p>Your journey with us will build skills that extend far beyond the screen—critical thinking, creative
                problem-solving, effective communication, and collaborative innovation. These are the skills that will
                define success in a world increasingly shaped by AI. Plus, they'll make you look super smart at family
                gatherings! 🧠🤓</p>

            <p>Join us in this adventure where detective skills meet digital creation. We can't wait to see what you'll
                discover, build, and share! Remember: in a world full of users, be a creator. In a world full of
                followers, be a leader. And in a world full of serious tech people, be the one who knows how to have fun
                while changing the future! 🎮🎭</p>

            <p>Let's start investigating! And remember, even Sherlock Holmes would have used AI if he had the chance—his
                violin playlist would have been FIRE! 🎻🔥</p>

            <p className="signature">Dr. RAS<br/>Founder, HackTonIA<br/>(The only doctor who prescribes more screen
                time, not less! 👩‍⚕️💻)</p>

            <h2>A Special Message from Justin Panther, AI-Guided Chief Detective 🐆🕵️‍♂️</h2>

            <p><strong>Hey there, rookie detectives! Justin Panther here, your AI-guided chief Detective at HackTonIA
                headquarters!</strong></p>

            <p>I've cracked some of the most mysterious cases in the digital universe, from "The Case of the
                Disappearing Webpage" to "The Mystery of the Moving Button." And let me tell you a secret: the clues are
                ALWAYS in the code! 🔍💻</p>

            <p>When Dr. RAS first recruited me, I thought AI was just another fancy abbreviation. Turns out it's my
                perfect partner in crime-solving (or rather, crime-preventing)! We're like peanut butter and jelly,
                except we solve digital mysteries instead of making sandwiches. 🥪🤖</p>

            <p>Remember, being a good detective isn't about knowing everything—it's about knowing how to find anything!
                And with AI by your side, you'll be uncovering digital clues faster than I can say "elementar-AI my dear
                Watson!"</p>

            <p>Can't wait to see you all at HackTivity headquarters. Bring your curiosity, your creativity, and your
                sense of humor—we're about to turn the internet inside out! 💪😎</p>

            <p className="signature">Justin Panther 🐆<br/>Chief Detective, HackTonIA<br/>"No code is too complex, no
                mystery too mysterious!"</p>
        </div>
    );
};

export default MissionAIForGoodOverview;
